"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _ramda = require("ramda");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var LinkedFieldWatcher = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(LinkedFieldWatcher, _Component);

  var _super = _createSuper(LinkedFieldWatcher);

  function LinkedFieldWatcher() {
    (0, _classCallCheck2["default"])(this, LinkedFieldWatcher);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(LinkedFieldWatcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prev) {
      var _this$props = this.props,
          value = _this$props.value,
          fieldName = _this$props.fieldName,
          linkType = _this$props.linkType,
          linkValue = _this$props.linkValue;

      if (prev.value !== value) {
        var isHidding = linkType === 'hide' || linkType === 'show';
        var valueMatch = value === linkValue;
        var needClear = isHidding && !valueMatch || isHidding && valueMatch;

        if (fieldName && needClear) {
          this.props.form.change(fieldName, undefined);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return LinkedFieldWatcher;
}(_react.Component);

var LinkedFieldWrapper = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(LinkedFieldWrapper, _Component2);

  var _super2 = _createSuper(LinkedFieldWrapper);

  function LinkedFieldWrapper() {
    (0, _classCallCheck2["default"])(this, LinkedFieldWrapper);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(LinkedFieldWrapper, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          field = _this$props2.field,
          fieldName = _this$props2.fieldName,
          form = _this$props2.form,
          children = _this$props2.children;
      var linkField = (0, _ramda.path)(['settings', 'linkField'], field);
      var linkType = (0, _ramda.path)(['settings', 'linkType'], field);
      var linkValue = (0, _ramda.path)(['settings', 'linkValue'], field);
      var required = field.required;
      var parent = "".concat(fieldName || '').replace(field.field, '');
      return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
        name: "".concat(parent).concat(linkField),
        subscription: {
          value: true
        }
      }, function (_ref) {
        var value = _ref.input.value;
        return /*#__PURE__*/_react["default"].createElement(LinkedFieldWatcher, {
          value: value,
          field: field,
          fieldName: fieldName,
          form: form,
          linkType: linkType,
          linkValue: linkValue
        }, linkType === 'hide' ? value === linkValue ? children({
          required: required
        }) : null : linkType === 'show' ? value !== linkValue ? children({
          required: required
        }) : null : value !== linkValue ? children({
          required: false
        }) : children({
          required: true
        }));
      });
    }
  }]);
  return LinkedFieldWrapper;
}(_react.Component);

var _default = LinkedFieldWrapper;
exports["default"] = _default;